import { Component, AfterViewChecked, ChangeDetectorRef, OnInit, NgZone, HostListener } from '@angular/core';
import { Router, Event, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationStart, NavigationEnd } from '@angular/router';
import { UiService } from './services/ui/ui.service';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewChecked {

  private _inputElems = [];
  private _modals = [];

  public showLoader = false;

  constructor(
    public ui: UiService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private zone: NgZone
  ) { }

  @HostListener('document:click')
  onDocumentClick() {
    $('.modal').on('hidden.bs.modal', () => {
      if ($('.modal-backdrop').length === 0) {
        setTimeout(() => {
          $('body').removeClass('modal-open');
        }, 0);
      } else if ($('.modal-backdrop').length >= 1 && !$('body').hasClass('modal-open')) {
        setTimeout(() => {
          $('body').addClass('modal-open');
        }, 0);
      }
    });
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.ui.loader.show('RouterConfigLoadStart');
      } else if (event instanceof RouteConfigLoadEnd) {
        this.ui.loader.hide('RouterConfigLoadEnd');
      }
    });
  }

  ngAfterViewChecked() {
    // $('.modal').on('hidden.bs.modal', () => {
    //   if ($('.modal').length > 1) {
    //     setTimeout(() => {
    //       $('body').addClass('modal-open');
    //     });
    //   }
    // });
    // if (this.showLoader !== this.ui._loaderCounter) {
    //   this.showLoader = this.ui._loaderCounter;
    this.cdRef.detectChanges();
    // }
    // this.inputAutofillOff();
  }

  inputAutofillOff() {
    this.zone.runOutsideAngular(() => {
      const self = this;
      this._inputElems = this._inputElems.filter(elem => {
        return document.body.contains(elem);
      });
      $('input').each(function () {
        if (!self._inputElems.includes(this)) {
          if (!this.hasAttribute('readonly')) {
            this.setAttribute('readonly', 'true');
            this.addEventListener('focus', function () { this.removeAttribute('readonly'); });
            this.addEventListener('blur', function () { this.setAttribute('readonly', 'true') });
            self._inputElems = [...self._inputElems, this];
          }
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/app.component.ts